import KYC from './KYC'
import Plan from './Plan'
import Portfolio from './Portfolio'
import Profile from './Profile'
import RiskAssessment from './RiskAssessment'

export default { KYC, Portfolio, Profile, RiskAssessment, Plan }
